var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDeleteDots = function SvgDeleteDots(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "5px",
    viewBox: "0 0 20 5",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "\xB7\xB7\xB7")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mockup---Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Announcement_freemium--Copy-30",
    transform: "translate(-1272.000000, -228.000000)",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "container",
    transform: "translate(360.000000, 156.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "messages",
    transform: "translate(320.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "announcement",
    transform: "translate(184.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "options-buttons",
    transform: "translate(406.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.11012967,8 C5.23031511,8 6.14142741,8.83699543 6.21512165,9.94294105 L6.21993324,10.0886734 L6.21058288,10.3125783 C6.10770868,11.381962 5.2026746,12.1818658 4.11012967,12.1818658 C2.98994423,12.1818658 2.07883193,11.3448704 2.00485067,10.2538318 L2,10.0717361 C2,8.91135987 2.94124052,8 4.11012967,8 Z M12,8 C13.1201854,8 14.0312977,8.83699543 14.104992,9.94294105 L14.1098036,10.0886734 L14.1004532,10.3125783 C13.997579,11.381962 13.0925449,12.1818658 12,12.1818658 C10.8798146,12.1818658 9.96870226,11.3448704 9.894721,10.2538318 L9.88987033,10.0717361 C9.88987033,8.91135987 10.8311108,8 12,8 Z M19.8898703,8 C20.9349133,8 21.8083963,8.73185911 21.9738907,9.75342588 L21.9920194,9.89448463 L22,10.1101297 C22,11.2705059 21.0587595,12.1818658 19.8898703,12.1818658 C18.8448274,12.1818658 17.9713444,11.4500067 17.8058499,10.4284399 L17.7877212,10.2873812 L17.7797407,10.0717361 C17.7797407,8.91135987 18.7209812,8 19.8898703,8 Z",
    id: "\\xB7\\xB7\\xB7"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteDots, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete_dots.04abe1df.svg";
export { ForwardRef as ReactComponent };